export enum DeltaBoolean {
    No = 0,
    Yes = 1
}